import { EntTerritorialsUnits } from '../handBooks/territorialsUnits'
import { EntDirectoryInfoName } from '../directoryInfoName'

export class EntFertilizerUsage {
	id: number | null = null
	territorialUnitRegion?: EntTerritorialsUnits | null = null
	periodStart: string | null = null
	periodEnd: string | null = null
	fertilizerUsageCrops: FertilizerUsageCrops[] | null = null
	territorialUnitRegionId: number | null = null
}

export class FertilizerUsageCrops {
	key: string | undefined = undefined
	id: number | null = null
	territorialUnitDistrictId: number | null = null
	territorialUnitDistrict?: EntTerritorialsUnits | null = null
	cropDetails: EntFertilizerUsageCrops[] | null = null
}

export class EntFertilizerUsageCrops {
	key: string | undefined = undefined
	id: number | null = null
	cropArea: number | null = null
	fertilizerArea: number | null = null
	cropTypeId: number | null = null
	percent?: number | null = null
	cropType?: EntDirectoryInfoName | null = null
}
